<template>
  <div v-if="name" class="text-sm bg-blue-100 dark:bg-gray-800 rounded-full inline-flex items-center px-4 py-0">
    {{ name }} <GMButton size="small" v-if="showCancel" icon-only icon-before="x" tertiary class="text-current" @click="$emit('cancel')"/>
  </div>
</template>

<script lang="ts">
import {GMButton, GMOrb} from '@gm/components'
import {useCustomerService} from "~/services/customerService";

export default defineComponent({
  props: {
    customerId: {
      type: String,
      required: true,
    },
    showCancel: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    GMOrb,
    GMButton,
  },
  setup(props) {
    const {customerQuery} = useCustomerService()
    const {data: customer} = customerQuery(props.customerId)
    const name = computed(() => customer.value?.Name)

    return {
      name
    }
  }
})
</script>
